<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="4"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          icon: 'mdi-keyboard-outline',
          title: 'Register Online',
          text: 'Register on this site to complete your electronic Z83 form.',
        },
        {
          icon: 'mdi-newspaper',
          title: 'Browse Job Adverts',
          text: 'If you see an advert with a Z83.co.za reference number, you can apply electronically',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Send SMS',
          text: 'Send the reference number from the advert to a special shortcode. Receive an acknowledgement SMS. Job Applied for!',
        },
      ],
    }),
  }
</script>
